import {
  GoogleTagManager,
  type GoogleTagManagerConfig,
} from '@/components/analytics/GoogleTagManager';
import { Blotout } from '@/components/analytics/Blotout';

const globalGTM: GoogleTagManagerConfig = {
  gtmId: import.meta.env['VITE_GTM_CONTAINER_ID'],
  auth: import.meta.env['VITE_GTM_AUTH'],
  preview: import.meta.env['VITE_GTM_PREVIEW'],
};

export function Analytics() {
  return (
    <>
      <GoogleTagManager {...globalGTM} />
      <Blotout />
    </>
  );
}
